(function () {
  function initOffersCarousels(root) {
    if (typeof Swiper === 'undefined') return;

    const scope = root || document;

    scope.querySelectorAll('[data-offers-carousel]:not([data-offers-initialized])').forEach((wrap) => {
      const swiperEl = wrap.querySelector('.product-about__offers-swiper');
      if (!swiperEl) return;

      const offersSection = wrap.closest('.product-about__offers');
      const section = wrap.closest('.product-about');
      const prevEl = offersSection?.querySelector('.product-about__offers-button-prev');
      const nextEl = offersSection?.querySelector('.product-about__offers-button-next');
      const gap = parseInt(getComputedStyle(section || document.documentElement).getPropertyValue('--product-about-offers-gap'), 10) || 12;

      wrap.dataset.offersInitialized = 'true';

      const swiperOptions = {
        slidesPerView: 'auto',
        spaceBetween: gap,
        grabCursor: true,
        watchOverflow: true,
        navigation: prevEl && nextEl ? { prevEl, nextEl } : false,
      };

      const swiper = new Swiper(
        swiperEl,
        typeof withIslandSwiperDefaults === 'function'
          ? withIslandSwiperDefaults(swiperOptions)
          : Object.assign({}, swiperOptions, {
              mousewheel: {
                enabled: true,
                forceToAxis: true,
                sensitivity: 1,
                releaseOnEdges: true,
                eventsTarget: 'container',
              },
            })
      );

      swiperEl.productAboutOffersSwiper = swiper;
    });
  }

  function destroyOffersCarousels(root) {
    const scope = root || document;

    scope.querySelectorAll('[data-offers-carousel][data-offers-initialized]').forEach((wrap) => {
      const swiperEl = wrap.querySelector('.product-about__offers-swiper');
      if (swiperEl?.productAboutOffersSwiper) {
        swiperEl.productAboutOffersSwiper.destroy(true, true);
        delete swiperEl.productAboutOffersSwiper;
      }

      delete wrap.dataset.offersInitialized;
    });
  }

  function bindOfferCopyButtons(root) {
    const scope = root || document;

    scope.querySelectorAll('[data-offer-copy]:not([data-offer-copy-bound])').forEach((button) => {
      button.dataset.offerCopyBound = 'true';

      button.addEventListener('click', async (event) => {
        event.preventDefault();
        event.stopPropagation();

        const code = button.dataset.discountCode;
        if (!code) return;

        const defaultState = button.querySelector('[data-offer-copy-default]');
        const successState = button.querySelector('[data-offer-copy-success]');
        if (!defaultState || !successState) return;

        try {
          await navigator.clipboard.writeText(code);
        } catch {
          return;
        }

        defaultState.hidden = true;
        successState.hidden = false;
        button.disabled = true;

        window.setTimeout(() => {
          defaultState.hidden = false;
          successState.hidden = true;
          button.disabled = false;
        }, 2000);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initOffersCarousels();
    bindOfferCopyButtons();
  });

  document.addEventListener('shopify:section:load', (event) => {
    initOffersCarousels(event.target);
    bindOfferCopyButtons(event.target);
  });
  document.addEventListener('shopify:section:unload', (event) => destroyOffersCarousels(event.target));
})();
